import { Role } from '../../types'
import { DataTable } from '@/shared/components/DataTable/DataTable'
import { formatDateDMY } from '@/shared/utils/formatDate'
import { StatusBadge } from '@/shared/components/StatusBadge/StatusBadge'

type AllRolesProps = {
    mode?: 'active' | 'deleted'
    roles: Role[]
    onEdit?: (role: Role) => void
    onDelete?: (role: Role) => void
    onRestore?: (role: Role) => void
}

export default function AllRoles({
    mode = 'active',
    roles,
    onEdit,
    onDelete,
    onRestore,
}: AllRolesProps) {
    const columns = mode === 'deleted'
        ? [
            {
                key: 'label',
                header: 'Role',
                render: (row: Role) => row.label,
            },
            {
                key: 'createdDate',
                header: 'Created Date',
                render: (row: Role) => formatDateDMY(row.createdDate ?? '-'),
            },
            {
                key: 'deletedDate',
                header: 'Deleted Date',
                render: (row: Role) => formatDateDMY(row.deletedDate ?? row.updatedDate ?? '-'),
            },
        ]
        : [
            {
                key: 'label',
                header: 'Role',
                render: (row: Role) => row.label,
            },
            {
                key: 'type',
                header: 'Role Type',
                render: (row: Role) => (
                    <StatusBadge
                        type={row.type === 'Default' ? 'verified' : 'unverified'}
                        labelOverride={row.type}
                    />
                ),
            },
            {
                key: 'createdDate',
                header: 'Created Date',
                render: (row: Role) => formatDateDMY(row.createdDate ?? '-'),
            },
            {
                key: 'associatedUsers',
                header: 'Associated Users',
                render: (row: Role) => row.associatedUsers,
            },
        ]

    const actions =
        mode === 'deleted'
            ? [
                {
                    icon: 'rotate_left',
                    label: 'Restore Role',
                    onClick: (row: Role) => onRestore?.(row),
                },
            ]
            : [
                {
                    icon: 'edit',
                    label: 'Edit Role',
                    onClick: (row: Role) => onEdit?.(row),
                },
                // {
                //     icon: 'groups',
                //     label: 'Duplicate Role',
                //     onClick: (row: Role) => onDuplicate?.(row),
                // },
                {
                    icon: 'delete',
                    label: 'Delete Role',
                    onClick: (row: Role) => onDelete?.(row),
                },
            ]

    return (
        <DataTable columns={columns} data={roles} actions={actions} />
    )
}
